const columnTitles = ({ translate }: { translate: (key: string) => string }): string[] => [
    translate(''),
    translate('table.columnsTitles.name'),
    translate('table.columnsTitles.contract'),
    translate('table.columnsTitles.establishment'),
    translate('table.columnsTitles.presentationDate'),
    translate('table.columnsTitles.stateSRT'),
    translate('table.columnsTitles.generationDate'),
    translate('table.columnsTitles.actions')
];

const columnWidths = ['2%', '5%', '5%', '25%', '25%', '15%', '15%', '5%'];

export { columnTitles, columnWidths };
